import { Box, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ToggleRow } from "./ToggleRow";

interface DiscoveryContentSectionProps {
  showMatureContent: boolean;
  hideAiResults: boolean;
  onToggle: (field: string, value: boolean) => void;
}

export function DiscoveryContentSection({
  showMatureContent,
  hideAiResults,
  onToggle,
}: DiscoveryContentSectionProps) {
  const [t] = useTranslation();

  return (
    <VStack spacing={5} align="stretch">
      <Text fontSize="xl" fontFamily="heading" fontWeight={600} color="dune.dune">
        {t("screens.settings.discoveryContent")}
      </Text>

      <Box>
        <ToggleRow
          label={t("screens.settings.showMatureContent")}
          description={t("screens.settings.showMatureContentDesc")}
          checked={showMatureContent}
          onChange={(v) => onToggle("show_mature_content", v)}
        />
        <ToggleRow
          label={t("screens.settings.hideAiContent")}
          description={t("screens.settings.hideAiContentDesc")}
          checked={hideAiResults}
          onChange={(v) => onToggle("hide_ai_results", v)}
          isLast
        />
      </Box>
    </VStack>
  );
}
